<template>
  <div class="layer-tem">
    <img
      :src="newClose"
      class="close-btn"
      alt=""
      @click="closeLayer"
    >
    <!-- 火警、报警、预警 -->
    <!-- 主内容 -->
    <div class="layer-main">
      <!-- 导航 -->
      <tab-nav
        :tabArr="tabArr"
        :parNavIndex="tabIndex"
        @index="tabIndexFn"
      ></tab-nav>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head block-head-form">
          <!-- 2个下拉框 -->
          <div class="form-wrap">
            <Select
              v-model="areaId"
              transfer
              :word-wrap="true"
              clearable
              style="width: 100px;margin-right: 10px;"
              placeholder="区域"
              @on-change="formChange"
            >
              <Option
                v-for="item in areaArr"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
            <Select
              v-model="industId"
              transfer
              :word-wrap="true"
              clearable
              style="width: 100px;"
              placeholder="行业"
              @on-change="formChange"
            >
              <Option
                v-for="item in industArr"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
          </div>
          <!-- 1个搜索框 -->
          <div class="form-wrap">
            <Input
              v-model="inpVal"
              style="width: 150px;"
              placeholder="请输入单位名称"
              @on-enter="formChange"
              @on-click="formChange"
              icon="ios-search"
            >
            </Input>
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <div class="table-wrap">
              <div class="table-head">
                <table>
                  <tr>
                    <th width="5%">序号</th>
                    <th
                      v-for="(item, index) in tableField_par"
                      :key="index"
                    >
                      {{item.th}}
                    </th>
                  </tr>
                </table>
              </div>
              <div
                class="table-body"
                id="layer-tem-scroll1"
              >
                <table>
                  <tr
                    v-for="(item, index) in tableArr_par"
                    :key="index"
                  >
                    <td width="5%">
                      {{index+1}}
                    </td>
                    <td>
                      <Poptip
                        v-if="item.name"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.name"
                      >
                        {{item.name}}
                      </Poptip>
                    </td>
                    <td>
                      <Poptip
                        v-if="item.areaName"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.areaName"
                      >
                        {{item.areaName}}
                      </Poptip>
                    </td>
                    <td>
                      <Poptip
                        v-if="item.industryCategoryName"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.industryCategoryName"
                      >
                        {{item.industryCategoryName}}
                      </Poptip>
                    </td>
                    <td>
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="tabIndex == 0 ? item.fireCount : tabIndex == 1 ? item.alarmCount : item.warnCount"
                      >
                        {{tabIndex == 0 ? item.fireCount : tabIndex == 1 ? item.alarmCount : item.warnCount}}
                      </Poptip>
                    </td>
                    <td>
                      <span
                        class="viewDetail"
                        @click="detailClick(item.id, item)"
                      >查看</span>
                    </td>
                  </tr>
                </table>
                <p
                  class="no-data"
                  v-show="!tableArr_par.length && getParStatus"
                >
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head block-head-text">
          <!-- 标题 -->
          <div class="tit">
            {{parTit}}警情信息
          </div>
          <!-- 消防负责人 -->
          <div class="text">
            消防负责人：{{titleTextObj.chargePersonName}}
          </div>
          <!-- 联系方式 -->
          <div class="text">
            联系方式：{{titleTextObj.chargePersonTel}}
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <div class="table-wrap">
              <div class="table-head">
                <table>
                  <tr>
                    <th width="5%">序号</th>
                    <th
                      v-for="(item, index) in tableField_detail"
                      :key="index"
                    >
                      {{item.th}}
                    </th>
                  </tr>
                </table>
              </div>
              <div
                class="table-body"
                id="layer-tem-scroll2"
              >
                <table>
                  <tr
                    v-for="(item, index) in tableArr_detail"
                    :key="index"
                  >
                    <td width="5%">{{index+1}}</td>
                    <td>
                      <Poptip
                        v-if="item.deviceName"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.deviceName"
                      >
                        {{item.deviceName}}
                      </Poptip>
                    </td>
                    <td>
                      <Poptip
                        v-if="item.ctime"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="timestamp(item.ctime)"
                      >
                        {{timestamp(item.ctime)}}
                      </Poptip>
                    </td>
                    <td>
                      <Poptip
                        v-if="item.content"
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.content"
                      >
                        {{item.content}}
                      </Poptip>
                    </td>
                    <td>
                      <span
                        class="viewDetail"
                        @click="showDetailLayer(item.orgId,item)"
                      >查看</span>
                    </td>
                  </tr>
                </table>
                <p
                  class="no-data"
                  v-show="!tableArr_detail.length && getDetailStatus"
                >
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import close from "@/assets/img/close.png";
import newClose from "@/assets/img/newClose.png";
import tabNav from "./tab-nav.vue";

import { timestampToTime } from "@/assets/js/index";
import tableTem from "./layer-table.vue";
export default {
  name: "",
  data: () => ({
    close,
    newClose,
    tabArr: ["火警", "报警", "预警"],
    tabIndex: 0,
    hashValue: "",
    loginData: {},
    currentPage: 1,
    inpVal: "",
    areaArr: [],
    areaId: "",
    industId: "",
    industArr: "",
    tableField_par: [
      {
        th: "单位名称",
        td: "name",
      },
      {
        th: "区域名称",
        td: "electricityquantity",
      },
      {
        th: "行业名称",
        td: "industryCategoryName",
      },
      {
        th: "当前火警数",
        td: "fireCount",
      },
      {
        th: "详情",
        td: "",
      },
    ],
    tableArr_par: [],
    tableGetDataObj_par: {
      name: null,
      areaId: null,
      industryCategory: null,
    },
    tableField_detail: [
      {
        th: "设备名称",
        td: "deviceName",
      },
      {
        th: "发生时间",
        td: "ctime",
      },
      {
        th: "警情内容",
        td: "content",
      },
      {
        th: "详情",
        td: "",
      },
    ],
    tableArr_detail: [],
    tableGetDataObj_detail: {},
    titleTextObj: {
      chargePersonName: "",
      chargePersonTel: "",
    },
    tableUrl_detail: "",
    currentPage_par: 1,
    currentPage_detail: 1,
    totalCount_par: "",
    totalCount_detail: "",
    parTit: "",
    getParStatus: false,
    getDetailStatus: false,
  }),
  watch: {
    layerType: {
      handler(newVal, oldVal) {
        console.log(newVal);
        console.log("弹窗类型");
        if (newVal == "midTop1") {
          //火警
          this.tabIndex = 0;
          this.tableField_par[3] = {
            th: "当前火警数",
            td: "fireCount",
          };
        } else if (newVal == "midTop2") {
          //报警
          this.tabIndex = 1;
          this.tableField_par[3] = {
            th: "当前报警数",
            td: "alarmCount",
          };
        } else if (newVal == "midTop3") {
          //预警
          this.tabIndex = 2;
          this.tableField_par[3] = {
            th: "当前预警数",
            td: "warnCount",
          };
        }
        //请求数据
        this.dataInit();
        this.getParTable();
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    tabNav,
    tableTem,
  },
  created() {
    this.hashValue = localStorage.getItem("hashValue");
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
  },
  mounted() {
    this.getAllData();
  },
  computed: {
    layerType() {
      return this.$store.state.showLayer.type;
    },
  },
  methods: {
    timestamp(time) {
      return timestampToTime(time);
    },
    showDetailLayer(id, item) {
      //显示详情弹窗
      this.$store.commit("baseInfoLayer", {
        detailStatus: true,
        baseInfoId: id,
        baseInfoItem: item,
      });
    },
    tabIndexFn(index) {
      //导航切换
      console.log(index);
      this.tabIndex = index;
      if (this.tabIndex == 0) {
        //火警
        this.tableField_par[3] = {
          th: "当前火警数",
          td: "fireCount",
        };
      } else if (this.tabIndex == 1) {
        //报警
        this.tableField_par[3] = {
          th: "当前报警数",
          td: "alarmCount",
        };
      } else if (this.tabIndex == 2) {
        //预警
        this.tableField_par[3] = {
          th: "当前预警数",
          td: "warnCount",
        };
      }
      //请求数据
      this.dataInit();
      this.getParTable();
    },
    getParTable() {
      //第一个table
      this.getParStatus = false;
      let _this = this;
      let dataObj = {
        type: "get",
        url: "/mcbw/dep_stats/run_statistics/list",
        obj: Object.assign(
          {
            pageSize: 50,
            sortType:
              this.tabIndex == 0
                ? "fire"
                : this.tabIndex == 1
                ? "alarm"
                : "warn",
            currentPage: this.currentPage_par,
          },
          this.tableGetDataObj_par
        ),
      };

      console.log(dataObj);

      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("第一个table数据");
        this.getParStatus = true;
        if (res.data.success) {
          this.totalCount_par = res.data.totalCount;
          if (res.data.data.length) {
            this.tableArr_par = [...this.tableArr_par, ...res.data.data];
            if (!this.tableArr_detail.length) {
              //点击第一个
              this.detailClick(this.tableArr_par[0].id, this.tableArr_par[0]);
            }
          }
        }
        this.$nextTick(() => {
          $JQ("#layer-tem-scroll1").mCustomScrollbar({
            callbacks: {
              onTotalScroll: function () {
                if (
                  _this.tableArr_par.length == res.data.totalCount ||
                  res.data.data.length == 0
                ) {
                  console.log("没有更多数据");
                  return;
                } else {
                  console.log("加载更多");
                  _this.currentPage_par += 1;
                  _this.getParTable();
                }
              },
            },
          });
        });
      });
    },
    detailClick(id, item) {
      this.tableArr_detail = [];
      this.currentPage_detail = 1;
      this.tableArr_detail = [];
      this.totalCount_detail = "";
      this.parTit = item.name;
      this.titleTextObj.chargePersonName = item.leaderName;
      this.titleTextObj.chargePersonTel = item.leaderPhone;
      this.detailTable(id);
    },
    detailTable(orgId) {
      //点击table查看详情
      this.getDetailStatus = false;
      let _this = this;
      switch (this.tabIndex) {
        case 0: //火警
          this.tableUrl_detail = "/mcbw/alarm_manage/fire";
          this.tableGetDataObj_detail = {
            sources: "3,6,7",
            orgId: orgId,
            beginTime: null,
            endTime: null,
            states: '0,1',
            type: null,
            content: null,
          };
          break;
        case 1: //报警
          this.tableUrl_detail = "/mcbw/alarm_manage/fire";
          this.tableGetDataObj_detail = {
            orgId: orgId,
            beginTime: null,
            endTime: null,
            states: '0,1',
            type: null,
            content: null,
          };
          break;
        case 2: //预警
          this.tableUrl_detail = "/mcbw/alarm_manage/warn";
          this.tableGetDataObj_detail = {
            orgId: orgId,
            beginTime: null,
            endTime: null,
            states: '0,1',
            type: null,
            content: null,
          };
          break;
      }

      let dataObj = {
        type: "get",
        url: this.tableUrl_detail,
        obj: Object.assign(
          {
            pageSize: 50,
            currentPage: this.currentPage_detail,
          },
          this.tableGetDataObj_detail
        ),
      };

      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("第二个table数据");
        this.getDetailStatus = true;
        if (res.data.success) {
          this.totalCount_detail = res.data.totalCount;
          if (res.data.data.length) {
            this.tableArr_detail = [...this.tableArr_detail, ...res.data.data];
          }
        }
        this.$nextTick(() => {
          $JQ("#layer-tem-scroll2").mCustomScrollbar({
            callbacks: {
              onTotalScroll: function () {
                if (
                  _this.tableArr_detail.length == res.data.totalCount ||
                  res.data.data.length == 0
                ) {
                  console.log("没有更多数据");
                  return;
                } else {
                  console.log("加载更多");
                  _this.currentPage_detail += 1;
                  _this.detailTable(orgId);
                }
              },
            },
          });
        });
      });
    },
    closeLayer() {
      this.$store.commit("showLayer", {
        status: false,
        type: "",
      });
    },
    dataInit() {
      //初始化数据
      this.tableArr_par = [];
      this.tableArr_detail = [];
      this.currentPage_par = 1;
      this.currentPage_detail = 1;
      this.totalCount_par = "";
      this.totalCount_detail = "";
      $JQ("#layer-tem-scroll1").mCustomScrollbar("update");
      $JQ("#layer-tem-scroll2").mCustomScrollbar("update");
    },
    getAllData() {
      //请求数据
      // 请求区域、行业数据
      this.getAreaData();
      this.getIndustData();
    },
    getAreaData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/departments/org/area",
        obj: {
          pageSize: 1000,
          currentPage: 1,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("区域数据");
        if (res.data.success && res.data.data.length) {
          this.areaArr = res.data.data;
        }
      });
    },
    formChange() {
      //改变表单
      console.log(this.areaId);
      console.log(this.industId);
      console.log(this.inpVal);

      this.tableGetDataObj_par = {
        name: this.inpVal || null,
        areaId: this.areaId || null,
        industryCategory: this.industId || null,
      };
      this.dataInit();
      this.getParTable();
    },
    getIndustData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/industryCategory/data",
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("行业数据");
        if (res.data.success && res.data.data.length) {
          this.industArr = res.data.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layer-tem {
  position: absolute;
  left: 500px;
  bottom: 0;
  width: calc(100% - 1000px);
  padding: 25px 15px;
  background: rgba(6, 18, 44, 1) url("../../assets/img/maskBg.png") center
    center/101% 102% no-repeat;
  z-index: 12;

  // 关闭按钮
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    right: 25px;
    top: 30px;
    cursor: pointer;
  }
  .block-head {
    margin: 10px 0;
    display: flex;
    align-items: center;
    &.block-head-form {
      justify-content: space-between;
    }
    &.block-head-text {
      color: #a2d8ff;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      .text {
        margin-right: 20px;
      }
    }
    .tit {
      min-width: 200px;
      margin-right: 20px;
    }
  }
  .block-main {
    height: 200px;
    position: relative;
    padding: 8px;

    .block-main-content {
      height: 100%;
      .table-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
        .table-head {
          background: #0c2745;
          color: #7db4db;
          font-family: Microsoft YaHei;
          font-weight: 400;
          table th {
            height: 30px;
          }
        }
        .table-body {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          color: #e4eff5;
          table td {
            text-align: center;
            height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e4eff5;
            i {
              cursor: pointer;
            }
          }
          table tr:nth-child(2n) {
            background: #0c2745;
          }
          .no-data {
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ddd;
          }
        }

        table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/midTopRight.vue